import berliininmunkki from '../assets/berliininmunkki.png'
import donitsi from '../assets/donitsi.png'
import heite from '../assets/heite.png'
import herkkumuffinssi from '../assets/herkkumuffinssi.png'
import kalja from '../assets/kalja.png'
import leijonalippu from '../assets/leijonalippu.png'
import munkki from '../assets/munkki.png'
import suklaadonitsi from '../assets/suklaadonitsi.png'
import suklaamuffinssi from '../assets/suklaamuffinssi.png'
import suklaamunkki from '../assets/suklaamunkki.png'

export const getRandomTexture = (): string => {
  const textures = [
    berliininmunkki,
    donitsi,
    heite,
    herkkumuffinssi,
    kalja,
    leijonalippu,
    munkki,
    suklaadonitsi,
    suklaamuffinssi,
    suklaamunkki,
  ]
  const randomIndex = Math.floor(Math.random() * textures.length)
  return textures[randomIndex]
}
